import { useNavigate } from "react-router-dom";
import Description from "../../../components/ui/Description";
import TitleStyles from "../../../components/ui/TitleStyles";
import ProgressBar from "../../../components/progressBar/ProgressBar";
import InputLinkGroup from "../../../components/inputLinkGroup/InputLinkGroup";
import ButtonGroup from "../../../components/ui/ButtonGroup";
import { Container, ContainerVideo, Position } from "./VideoStyles";
import { usePressKit } from "../../../context/PressKitContext";

const convertToEmbedUrl = (url: string): string => {
  const regex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w\-]+)/;
  const match = url.match(regex);
  return match ? `https://www.youtube.com/embed/${match[1]}` : "";
};

const Video = () => {
  const navigate = useNavigate();
  const { pressKitData, setPressKitData } = usePressKit();
  const videoUrl = pressKitData.videoUrl;

  return (
    <Container>
      <TitleStyles>Vídeo</TitleStyles>
      <Description>Adicione um vídeo relevante na sua carreira</Description>

      <InputLinkGroup
        nameLabel="YouTube"
        namePlaceholder="YouTube:"
        urlLabel="Link"
        urlPlaceholder="https://www.link.com"
        allowAdd={false}
        previewEnabled={false}
        onChange={(items) => {
          if (items.length > 0) {
            setPressKitData((prev) => ({
              ...prev,
              videoUrl: items[0].url,
            }));
          }
        }}
      />

      {videoUrl && convertToEmbedUrl(videoUrl) && (
        <ContainerVideo>
          <iframe
            width="100%"
            height="100%"
            src={convertToEmbedUrl(videoUrl)}
            title="Vídeo do YouTube"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </ContainerVideo>
      )}

      <Position>
        <ProgressBar totalSteps={9} currentStep={3} />
        <ButtonGroup
          onBack={() => navigate("/events")}
          onNext={() => navigate("/photo")}
        />
      </Position>
    </Container>
  );
};

export default Video;
